import React, { useEffect, useRef } from 'react';
import { Routes, Route, useLocation, useNavigate, Navigate } from 'react-router-dom';
import Lenis from '@studio-freight/lenis';
import Home from './components/Home';
import Product from './components/Product';
import Experience from './components/Experience1';
import Experience2 from './components/Experience2';
import Materials from './components/Materials';
import Review from './components/Review';
import AboutUs from './components/aboutUs';
import Contact from './components/Contact';
import MoreProducts from './components/moreProducts';
import './App.css';
import PageSection from './components/PageSection';

export default function App() {
  const lenis = useRef(null);
  const location = useLocation();
  const navigate = useNavigate();

useEffect(() => {
  lenis.current = new Lenis({
    duration: 0.8,
    easing: t => 1 - Math.pow(1 - t, 3),
    smooth: true,
    smoothTouch: true,
  });

  // ✅ Make Lenis available globally
  window.lenis = lenis.current;

  const animate = (time) => {
    lenis.current.raf(time);
    requestAnimationFrame(animate);
  };
  requestAnimationFrame(animate);

  return () => {
    lenis.current.destroy();
    window.lenis = null;
  };
}, []);


  useEffect(() => {
    const handleLinkClick = (e) => {
      const link = e.currentTarget;
      const targetId = link.getAttribute('href');
      if (targetId?.startsWith('#')) {
        e.preventDefault();
        const targetEl = document.querySelector(targetId);
        if (targetEl && lenis.current) {
          lenis.current.scrollTo(targetEl, {
            offset: 0,
            duration: 1.2,
            easing: (t) => 1 - Math.pow(1 - t, 3),
          });

          // Set URL to match section
          const path = targetId.replace('#', '');
          navigate(`/${path}`, { replace: true });
        }
      }
    };

    const links = document.querySelectorAll('.nav-link');
    links.forEach(link => link.addEventListener('click', handleLinkClick));

    return () => {
      links.forEach(link => link.removeEventListener('click', handleLinkClick));
    };
  }, [navigate]);

  // On URL change (manual navigation), scroll to section
  useEffect(() => {
    const section = location.pathname.replace('/', '') || 'home';
    const el = document.getElementById(section);
    if (el && lenis.current) {
      lenis.current.scrollTo(el, {
        offset: 0,
        duration: 1.2,
        easing: (t) => 1 - Math.pow(1 - t, 3),
      });
    }
  }, [location]);

  return (
    <Routes>
      <Route
        path="/*"
        element={
          <>
            <PageSection id="home"><Home /></PageSection>
            <PageSection id="product"><Product /></PageSection>
            <PageSection id="showcase"><Experience /></PageSection>
            <PageSection><Experience2 /></PageSection>
            <PageSection id="materials"><Materials /></PageSection> 
            <PageSection id="review"><Review /></PageSection>
            <PageSection id="about-us"><AboutUs /></PageSection>
            <PageSection id="contact"><Contact /></PageSection>
          </>
        }
      />
      <Route path="/more-products" element={<MoreProducts />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
